module.exports = __webpack_public_path__ + "img/aws.082444af.png";